// this is a list of routes that are protected and require a user to be logged in to access
export const protectedRoutes = [];